<template lang="pug">
  hotsite-dcom
    .conteudo
      contato.contato-dcom
        p 
          strong FALE CONOSCO
        ul
          li: span Telefone institucional: (84) 3342-2274
          li
            span Secretaria Administrativa: 
            | 
            a(href="mailto:secretaria@dmp.ufrn.br") secretaria@dmp.ufrn.br
            | 
            span / Ramais 107 e 114

          li
            span Setor de Aquisições: 
            | 
            a(href="mailto:falecomaquisicoes@dmp.ufrn.br") falecomaquisicoes@dmp.ufrn.br
            | 
            span / Ramal: 106

          li
            span Setor de Contratações: 
            | 
            a(href="mailto:falecomcontratacoes@dmp.ufrn.br") falecomcontratacoes@dmp.ufrn.br
            | 
            span / Ramal: 119

          li
            span Setor de Licitações: 
            | 
            a(href="mailto:cpl@dmp.ufrn.br") cpl@dmp.ufrn.br
            | 
            span / Ramais: 115 e 129

          li
            span Setor de Pós-Compra: 
            | 
            a(href="mailto:poscompra@dmp.ufrn.br") poscompra@dmp.ufrn.br
            | 
            span / Ramais: 143 e 144
          
          li
            span Setor de Controle e Registro Contábil:
            | 
            a(href="mailto:controlepatrimonial@dmp.ufrn.br") controlepatrimonial@dmp.ufrn.br
            | 
            span / Ramal: 151

          li
            span Setor de Patrimônio:
            | 
            a(href="mailto:patrimonio.ufrn@gmail.com") patrimonio.ufrn@gmail.com
            | 
            span / Ramais: 134, 135, 136 e 137

          li
            span Seção de Importação: 
            | 
            a(href="mailto:dimport@dmp.ufrn.br") dimport@dmp.ufrn.br
            | 
            span / Ramais: 126 e 127

          li
            span Setor de Almoxarifado: 
            | 
            a(href="mailto:almoxarifadocentral@dmp.ufrn.br") almoxarifadocentral@dmp.ufrn.br
            | 
            span / Telefone: 3215-3340

          li
            span Setor de Almoxarifado de Manutenção de Obras: 
            | 
            a(href="mailto:almoxarifadonovodmp@gmail.com") almoxarifadonovodmp@gmail.com
            | 
            span / Telefone: 3342-2399 / Ramais: 220, 221 e 223
        p Para demais informações, dúvidas ou sugestões entre em contato através do formulário abaixo:
        //- TODO: Verificar se o destino abaixo também mudará para DCOM
        formulario(:destino="'dmp'")
      localizacao
        p Texto com o endereço da unidade...
</template>

<style lang="scss">
.contato-dcom {
  p {
    margin: 15px 0;
  }
}
</style>


<script>
  import Contato from 'MODULES/HotsiteContato'
  import Formulario from 'COMPONENTS/Formulario'
  import Localizacao from 'MODULES/HotsiteMapa'
  import HotsiteDcom from 'PAGES/dcom/Base'

  export default {
    components: {
      Contato,
      Formulario,
      Localizacao,
      HotsiteDcom
    }
  }
</script>



// WEBPACK FOOTER //
// Contato.vue?2b4b8824